import { i18n } from 'i18n';
import { ELanguages } from 'shared/typings';

export const LANGUAGES = [
	{
		label: i18n.t('EN'),
		value: ELanguages.EN,
	},
];

export const FULL_LANGUAGES = [
	{
		label: i18n.t('English'),
		value: ELanguages.EN,
	},
];

export const DEFAULT_LANGUAGE = (language: ELanguages) => {
	return LANGUAGES.find(({ value }) => language.includes(value))?.value || ELanguages.EN;
};
